import { render, staticRenderFns } from "./DeleteWastes.vue?vue&type=template&id=1361e375&scoped=true&"
import script from "./DeleteWastes.vue?vue&type=script&lang=js&"
export * from "./DeleteWastes.vue?vue&type=script&lang=js&"
import style0 from "./DeleteWastes.vue?vue&type=style&index=0&id=1361e375&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1361e375",
  null
  
)

export default component.exports